import { colors } from 'constants/styles/colors';
import { screenMd } from 'constants/styles/breakpoints';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
  padding: 30px;
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 26px;
  color: ${colors.fonts.dark};
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export const NoUsersTitle = styled.h1`
  font-weight: 700;
  font-size: 32px;
  line-height: 38px;
  color: ${colors.fonts.dark};
  margin-top: 70px;
  text-align: center;
`;

export const EmptySonarStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const SonarEmptyStateTitle = styled.h5`
  color: ${colors.fonts.dark};
  margin-bottom: 10px;
  text-align: center;
  font-family: var(--font-family-base);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
`;

export const SonarEmptyStateSubtitle = styled.span`
  color: ${colors.fonts.darkGray};
  margin-bottom: 20px;
  text-align: center;
  font-family: var(--font-family-base);
  font-size: 16px;
  font-style: normal;
`;

export const LoadingContainer = styled.div`
  position: relative;
  min-height: 160px;
  width: 100%;
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 140px;
  row-gap: 20px;
  column-gap: 20px;
  grid-template-columns: auto auto auto;
  justify-content: start;

  ${screenMd} {
    padding-bottom: 0;
  }
`;
